import { render, staticRenderFns } from "./detail_config_dataset_group_add.vue?vue&type=template&id=b07386da"
import script from "./detail_config_dataset_group_add.vue?vue&type=script&lang=js"
export * from "./detail_config_dataset_group_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b07386da')) {
      api.createRecord('b07386da', component.options)
    } else {
      api.reload('b07386da', component.options)
    }
    module.hot.accept("./detail_config_dataset_group_add.vue?vue&type=template&id=b07386da", function () {
      api.rerender('b07386da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/customform/detail_config_dataset_group_add.vue"
export default component.exports